import React from "react";
import { createRoot } from "react-dom/client";
import OperatorCapacityData from "./OperatorCapacityData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderOperatorCapacityData: unknown;
	}
}

export function renderOperatorCapacityData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<OperatorCapacityData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderOperatorCapacityData = renderOperatorCapacityData;
